// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"41":"ProposalsPage","106":"ProposalPage","415":"WalletPage","750":"TreasuryPage"}[chunkId] + "-legacy." + {"41":"77ea00fd","106":"a6334d63","415":"6b698078","750":"d478fa4e"}[chunkId] + ".js";
};